import React, { Fragment } from 'react';
import { CheckCircleIcon, TruckIcon, MapPinIcon } from 'lucide-react';
interface TimelinePoint {
  id: string;
  title: string;
  description: string;
  timestamp: string;
  status: 'completed' | 'current' | 'upcoming';
  type: 'pickup' | 'delivery' | 'in_transit';
}
interface ShipmentHorizontalTimelineProps {
  points: TimelinePoint[];
}
const ShipmentHorizontalTimeline: React.FC<ShipmentHorizontalTimelineProps> = ({
  points
}) => {
  const getEventIcon = (type: string, status: string) => {
    const baseClass = status === 'completed' ? 'text-green-600' : status === 'current' ? 'text-primary-600' : 'text-gray-400';
    switch (type) {
      case 'pickup':
        return <MapPinIcon size={16} className={baseClass} data-id="element-405" />;
      case 'delivery':
        return <CheckCircleIcon size={16} className={baseClass} data-id="element-406" />;
      case 'in_transit':
        return <TruckIcon size={16} className={baseClass} data-id="element-407" />;
      default:
        return null;
    }
  };
  const getProgressBarColor = (index: number, points: TimelinePoint[]) => {
    const currentIndex = points.findIndex(point => point.status === 'current');
    if (index >= points.length - 1) return ''; // No bar after last point
    if (index < currentIndex) return 'bg-green-500'; // Completed
    if (index === currentIndex) return 'bg-primary-500'; // Current
    return 'bg-gray-200'; // Upcoming
  };
  return <div className="w-full py-2" data-id="element-408">
      <div className="relative" data-id="element-409">
        {/* Timeline Points */}
        <div className="relative flex justify-between items-center" data-id="element-410">
          {points.map((point, index) => <Fragment key={point.id} data-id="element-411">
              <div className="flex flex-col items-center relative z-10" data-id="element-412">
                {/* Icon */}
                <div className={`flex h-8 w-8 items-center justify-center rounded-full border-2 bg-white
                    ${point.status === 'completed' ? 'border-green-500' : point.status === 'current' ? 'border-primary-500 ring-4 ring-primary-50' : 'border-gray-300'}`} data-id="element-413">
                  {getEventIcon(point.type, point.status)}
                </div>
                {/* Label */}
                <div className="mt-2 text-center min-w-[120px]" data-id="element-414">
                  <h4 className={`text-sm font-medium ${point.status === 'current' ? 'text-primary-700' : 'text-gray-900'}`} data-id="element-415">
                    {point.title}
                  </h4>
                  <p className="mt-0.5 text-xs text-gray-500" data-id="element-416">
                    {point.timestamp}
                  </p>
                  <p className="mt-0.5 text-xs text-gray-600" data-id="element-417">
                    {point.description}
                  </p>
                </div>
              </div>
              {/* Progress Bar */}
              {index < points.length - 1 && <div className="flex-1 h-0.5 relative z-0" data-id="element-418">
                  <div className={`h-full ${getProgressBarColor(index, points)}`} data-id="element-419" />
                </div>}
            </Fragment>)}
        </div>
      </div>
    </div>;
};
export default ShipmentHorizontalTimeline;